<template>
  <div class="room-attendance-modal-component">
    <div class="room-attendance-modal">
      <div class="room-attendance-header">
        <div class="flex items-center gap-x-2">
          <div class="room-attendance-title">{{ $t("attendance.modal.title") }} </div>
          <div class="room-attendance-note text-sm">{{ $t("attendance.modal.note") }} </div>
        </div>
        <GrmCloseBtn @click="onClose" />
      </div>
      <div class="room-attendance-body">
        <RoomAttendanceTable 
          :attendanceList="attendanceListProp" />
      </div>
      <div class="room-attendance-footer">
        <GrmBtn @click="handleClickDownloadFile">{{ $t("attendance.modal.exel.title") }}</GrmBtn>
      </div>
    </div>
    <div class="room-attendance-mobile-modal">
      <div class="room-attendance-mobile-header">
        <button class="room-attendance-mobile-btn back" 
                @click="onClose" />
        <div class="room-attendance-mobile-title">{{ $t("attendance.modal.title") }}</div>
        <button class="room-attendance-mobile-btn excel" 
                @click="handleClickDownloadFile" />
      </div>
      <div class="room-attendance-note text-sm">{{ $t("attendance.modal.note") }}</div>
      <div class="room-attendance-mobile-body">
        <RoomAttendanceMobileList
          :attendanceList="attendanceListProp" />
      </div>
    </div>
  </div>
</template>

<script>
import GrmCloseBtn from '@/components/Common/button/GrmCloseBtn'
import RoomAttendanceTable from '@/components/Room/Attendance/Table'
import RoomAttendanceMobileList from "@/components/Room/Attendance/MobileList";
import {Device} from "@/utils";

import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import GrmBtn from "@/components/Common/button/GrmBtn.vue";

export default {
  name: 'RoomAttendanceModal',
  components: {
    GrmBtn,
    GrmCloseBtn,
    RoomAttendanceTable,
    RoomAttendanceMobileList
  },
  computed: {
    ...mapGetters('user', [
      'isMe',
      'roomUserList',
      'attendanceList',
    ]),
    getFormedDate() {
      return date => {
        return date && moment(date).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    getDurationDate() {
      return sec => {
        let min = 0;
        let hours = 0;

        if(sec) {
          min = parseInt(sec/60);
          hours = parseInt(min/60);
          min %= 60;
          sec %= 60;
        }

        return `${hours}:${(0 <= min && min<10 ? '0':'').concat(min)}:${(0 <= sec && sec < 10 ? '0':'').concat(sec)}`;
      }
    },
  },
  data(){
    return {
      attendanceListProp: [],
    }
  },
  watch: {
    roomUserList: async function() {
      await this.updateAttendanceList();
      this.syncAttendance(this.attendanceList);
    }
  },
  created() {
    this.initCreated();
  },  
  methods: {
    ...mapActions('user', [
       'updateAttendanceList', 
    ]),
    isMobile(){
      return Device.isMobile();
    },
    async initCreated() {
      await this.updateAttendanceList();
      this.syncAttendance(this.attendanceList);
    },
    onClose() {
      this.$modal('RoomAttendanceModal')
    },
    getUserAgent(){
      const userAgentArr = navigator.userAgent.split(' ');
      const lastText = userAgentArr[userAgentArr.length-1];

      return lastText;
    },
    async handleClickDownloadFile() {
      if(this.getUserAgent() === 'BizNativeApp'){
        this.$alert({
          text: this.$t('attendance.modal.exel.mobile'),
          onlyOk: true
        })
        return;
      }
      const rows = this.attendanceListProp.map(row => ({
        name: row.nickname,
        present: row.present ? 'O':'X',
        firstEnter: this.getFormedDate(row.firstEnter),
        lastLeave: this.getFormedDate(row.lastLeave),
        totalTime: this.getDurationDate(row.totalAttendingSeconds),
        kickCount: row.kickCount,
        email: row.email || this.$t('attendance.modal.nonMember')
      }));

      const XLSX = await import('xlsx');
      const workSheet = XLSX.utils.json_to_sheet(rows);
      XLSX.utils.sheet_add_aoa(
        workSheet,
        [
          [
            this.$t('common.name'), this.$t('attendance.modal.nowEntered'), this.$t('attendance.list.init'),
            this.$t('attendance.list.last'), this.$t('attendance.list.total'), this.$t('attendance.list.kickCount'),
            this.$t('attendance.list.email')
          ]
        ],
        {origin: "A1"}
      )
      
      workSheet["!cols"] = [ 
        {wch: 10},  
        {
          wch: 12,
          alignment: {
            vertical: "center",
            horizontal: "center",
            wrapText: '1', // any truthy value here
          },
        },
        {wch: 18},
        {wch: 18},
        {wch: 11},
        {wch: 23},
      ];
      
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, this.$t("attendance.modal.title"))

      XLSX.writeFile(workBook, `${moment().format('YYMMDDhhmmss')}_${this.$t("attendance.modal.title")}.xlsx`, { compression: true });
    },
    syncAttendance(attendanceList){
      const ruLength = this.roomUserList.length;
      let attLength;

      if(attendanceList){
        this.attendanceListProp = [...attendanceList];
        attLength = attendanceList.length;
      }else{
        attLength = this.attendanceListProp.length;
      }
      
      let i = 0;
      let j = attLength-1;
      let continueFlag = false;

      for(i=0; i <= ruLength; i++){
        const attendance = this.attendanceListProp[i];
        if (!attendance) {
          continue;
        }
        attendance.present = false;  // 퇴장한 사용자 초기화
      }
      
      for(i = 0; i < ruLength; i++){
        continueFlag = false;
        for(; j > -1; j--) { // 성능개선 위해서는 binary search 필요
          if(this.roomUserList[i].userId == this.attendanceListProp[j].userId){
            const {username, nickname} = this.roomUserList[i];
            let temp = Object.assign({}, 
                this.attendanceListProp.splice(j, 1)[0],
                {username, nickname},
            )
            temp.present = true;
            temp.lastEnter = new Date(this.roomUserList[i].enterDate);
            temp.totalAttendingSeconds += parseInt((Date.now() - temp.lastEnter.getTime())/1000);
            this.attendanceListProp.splice(0, 0 ,temp)
            continueFlag = true;
            break;
          }
        }
        if(continueFlag) continue;

        if(!this.roomUserList[i].leaveDate){ // 최초 입장 유저의 경우
          const {
            nickname,
            username,
            userId,
            enterDate,
            user: {email} = {},
          } = this.roomUserList[i]

          this.attendanceListProp.splice(0, 0 ,{
            nickname,
            username,
            userId,
            email,
            firstEnter: enterDate,
            lastEnter: enterDate,
            totalAttendingSeconds: parseInt((Date.now() - new Date(enterDate).getTime())/1000),
            present: true,
          })
          j++;
          continue;
        }else{ // 재입장의 경우
          for(j = attLength-1; j > -1; j--) { // 성능개선 위해서는 binary search 필요
            if(this.roomUserList[i].userId == this.attendanceListProp[j].userId){
              let temp = Object.assign({}, this.attendanceListProp.splice(j, 1)[0])
              temp.present = true;
              temp.lastEnter = new Date(this.roomUserList[i].enterDate);
              temp.totalAttendingSeconds += parseInt((Date.now() - temp.lastEnter.getTime())/1000);
              this.attendanceListProp.splice(0, 0 ,temp)
              break;
            }
          }
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.room-attendance-modal-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 60px;
  z-index: 1;
}
.room-attendance-modal {
  width: 960px;
  border-radius: 6px;
  padding: 30px;
  background-color: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
}
.room-attendance-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.room-attendance-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
}
.room-attendance-body {
  margin-top: 20px;
}
.room-attendance-footer {
  margin-top: 24px;
  display: flex;
}

// mobile
.room-attendance-mobile-modal {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: none;
  flex-direction: column;
}
.room-attendance-mobile-header {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.room-attendance-mobile-modal .room-attendance-note {
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.room-attendance-mobile-btn {
  width: 50px;
  height: 100%;
  position: absolute;
  &.back {
    background: url('~@/assets/images/arrowLineThickLeft_gray.svg') no-repeat center / 18px auto;
    left: 0;
  }
  &.excel {
    background: url('~@/assets/images/excel.svg') no-repeat center / 24px auto;
    right: 0;
  }
}
.room-attendance-mobile-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
}
.room-attendance-mobile-body {
  min-height: 0;
  flex: 1;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #eaeaea;
  overflow-y: auto;
}

[grm-device-mobile] {
  .room-attendance-modal-component {
    left: 0;
    z-index: 4;
  }
  .room-attendance-modal {
    display: none;
  }
  .room-attendance-mobile-modal {
    display: flex;
  }
}
</style>